import { useDocumentTitle } from "@uidotdev/usehooks";
import { MapViewV2 } from "../components/MapV2/MapViewV2";
import { PermissionGate } from "./PermissionGate";

export const MapPage = () => {
    useDocumentTitle("Map - AERSHED");

    return (
        <PermissionGate permission="mapView">
            <MapViewV2 />
        </PermissionGate>
    );
};
